export enum UserRole {
  ADMIN = 'Admin',
  SPORTCONTRIBUTOR = 'SportContributor',
  COUNTRYCONTRIBUTOR = 'CountryContributor',
  UNAUTHORIZED = 'Unauthorized',
}
